import { Component, Input, OnChanges } from '@angular/core';
import { AppErrorLayoutComponent } from '../core/apperror.layout.component';

@Component({
    selector: 'app-apperrorlayoutdesktop',
    templateUrl: './apperror.layout.desktop.component.html',
    styleUrls: ['../css/apperror.layout.desktop.component.scss'],
    standalone: false
})
export class AppErrorLayoutDesktopComponent extends AppErrorLayoutComponent {
  errorMessageTranslateCode: string;
  additionalErrorCode: string;

  constructor() {
    super();
  }

  ngOnInit() {
    this.errorMessageTranslateCode = this.resolveErrorMessage();
    this.additionalErrorCode = this.data?.additionalErrorCode;
  }

  resolveErrorMessage() {
    if (this.data?.specificMessageCode) {
      return this.data?.specificMessageCode;
    }
    switch (this.data?.httpCode) {
      case 401: {
        return 'LANG00039';
      }
      default: {
        return 'LANG00034';
      }
    }
  }
}
